<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Гости школы</h2>
          <v-spacer></v-spacer>
          <v-text-field
            class="mx-5"
            outlined clearable hide-details dense flat label="фильтр" v-model="search" style="max-width: 300px"
          ></v-text-field>
          <v-dialog
            v-model="dialogImportGuest"
            scrollable persistent modal
            width="640"
            transition="dialog-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn class="mr-4" color="primary" v-on="on">Добавить в школу ГОСТЯ</v-btn>
            </template>
            <v-card>
              <v-card-title class="subtitle-1">
                Добавить в школу ГОСТЯ
                <v-spacer></v-spacer>
                <v-btn icon small @click="dialogImportGuestClose()"><v-icon>close</v-icon></v-btn>
              </v-card-title>
              <v-card-actions class="px-5">
                <v-text-field
                v-model="digICardId"
                label="Номер карты"
                counter="9"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn @click="digSearchPerson()" :disabled="!digICardId || digICardId.length !== 9" color="primary">Искать по карте</v-btn>
              </v-card-actions>
              <v-card-text>

                <v-text-field
                :value="digPerson ? (digPerson.fullname + ' ' + (digPerson.position ? (digPerson.position.schoolid + ' ' + digPerson.position.name) : '')) : ''"
                label="Пользователь"
                :disabled="true"
                ></v-text-field>

              </v-card-text>
              <br /><br />

              <v-card-actions>
                <v-btn
                  color="primary"
                  :disabled="inaction || !digPerson"
                  @click="addGuest()"
                >
                  Добавить
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn text
                  @click="dialogImportGuestClose()"
                >Отмена</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </v-flex>
      <v-flex>
        <v-data-table
          no-data-text="пусто"
          no-results-text="ничего не найдено"
          loading-text="идет загрузка"
          :footer-props="footerProps"
          :loading="inaction"
          :headers="headers"
          :items="guests"
          item-key="guestid"
          :search="search"
          :items-per-page="20"
          sort-by="cts"
          sort-desc
          dense
        >
          <template v-slot:item.action="{ item }">
            <v-btn color="error" x-small text @click="deleteItem(item)">
              удалить
              <v-icon small>delete</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.cts="{ item }">
            {{ dateFormat(item.cts) }}
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Guests',
  data: () => ({
    guests: [],
    inaction: false,
    search: '',
    dialogImportGuest: false,
    digPerson: null,
    digICardId: null,
    digIPositionId: null,
    headers: [
      { text: 'дата добавления', value: 'cts', width: '150', filter: (value, search, item) => true },
      { text: 'имя', value: 'fullname', width: '300' },
      { text: 'школа', value: 'schoolid', width: '100' },
      { text: 'класс', value: 'positionname', width: '100' },
      { text: 'действия', value: 'action', sortable: false },
    ],
    footerProps: {
      itemsPerPageText: 'Показывать:',
      itemsPerPageOptions: [20, 40, 100, { text: 'Все', value: -1 }]
    },
    iname: null,
    itype: null,
  }),
  methods: {
    async fetch () {
      try {
        this.inaction = true
        const { guests, meta } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-guests'
        })
        this.guests = guests
      } catch (err) {
        this.$store.dispatch('snack', err)
      } finally {
        this.inaction = false
      }
    },
    dialogImportGuestClose () {
      this.dialogImportGuest = false
      this.digPerson = null
      this.digICardId = null
      this.digIPositionId = null
    },
    async deleteItem (item) {
      try {
        await this.$store.dispatch('confirm', `Удалить ГОСТЯ ${item.fullname}`)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'delete-guest',
          pl: {
            guestid: item.guestid
          }
        })
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.fetch()
      }
    },
    async addGuest () {
      try {
        if (this.inaction) return
        this.inaction = true
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'add-guest',
          pl: {
            personid: this.digPerson.personid
          }
        })
        this.$store.dispatch('snack', meta)
        this.dialogImportGuestClose()
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.inaction = false
        this.fetch()
      }
    },
    async digSearchPerson () {
      try {
        const { meta, person } = await this.$store.dispatch('sioRequest', {
          topic: 'search-person',
          pl: {
            cardid: this.digICardId
          }
        })
        this.digPerson = person
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    scopes () {
      return this.profile ? this.profile.scopes : []
    },
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    }
  },
  mounted () {
    if (this.profile) this.fetch()
  }
}
</script>

<style lang="css">
</style>
